import React, { useEffect, useState } from "react";
import { useProfile } from './ProfileContext';
import iconProfile from './arrow.png';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";




function Header() {
  const navigate = useNavigate();
  const { selectedProfileId } = useProfile();
  const [user, setUser] = useState({});
  const [notifications, setNotifications] = useState([]);
  const [profilePic, setProfilePic] = useState('');
  const [medias, setMedias] = useState([]);
  const [recherche, setRecherche] = useState('');
  const [isSearchFocused, setIsSearchFocused] = useState(false);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseUser = await fetch('/user/details-user');
        const responseMedia = await fetch('/media/list-media');

        if (responseUser.status === 200) {
          const userData = await responseUser.json();
          setUser(userData);
          fetchNotifications(userData.userId);
        } else {
          console.error(`Error fetching user details: ${responseUser.status}`);
        }

        if (responseMedia.status === 200) {
          const mediaData = await responseMedia.json();
          setMedias(mediaData);
        } else {
          console.error(`Error fetching media list: ${responseMedia.status}`);
        }
      } catch (error) {
        console.error('Unexpected error fetching data:', error);
      }
    };

    if (selectedProfileId) {
      fetchData();
    } else {
      navigate("/");
    }
  }, [selectedProfileId]);

  useEffect(() => {
    if (selectedProfileId) {
      fetchPicProfile(selectedProfileId);
    }
  }, [selectedProfileId]);

  const fetchNotifications = async (userId) => {
    try {
      const response = await fetch(`/user/notifications/${userId}`);
      if (response.status === 200) {
        const notificationsData = await response.json();
        setNotifications(notificationsData);
      } else {
        console.error(`Error fetching notifications: ${response.status}`);
      }
    } catch (error) {
      console.error(`Unexpected error fetching notifications:`, error);
    }
  };

  const fetchPicProfile = async (profileId) => {
    try {
      const response = await fetch(`/profile/pic/${profileId}`);
      if (response.status === 200) {
        const profilePicData = await response.json();
        setProfilePic(profilePicData);
      } else {
        console.error(`Error fetching profile picture: ${response.status}`);
      }
    } catch (error) {
      console.error(`Unexpected error fetching profile picture:`, error);
    }
  };

  const handleNotificationClick = async (notificationId) => {
    // Mettre à jour localement
    const updatedNotifications = notifications.map((notification) =>
      notification._id === notificationId
        ? { ...notification, isRead: !notification.isRead } // Inverse l'état "read"
        : notification
    );
    setNotifications(updatedNotifications);

    // Mettre à jour côté serveur
    try {
      const response = await fetch(`/user/notifications/${notificationId}`, {
        method: 'POST',
      });

      if (response.status !== 200) {
        console.error(`Error marking notification as read: ${response.status}`);
        // En cas d'erreur côté serveur, annuler la mise à jour locale
        setNotifications(notifications);
      }
    } catch (error) {
      console.error('Unexpected error marking notification as read:', error);
      // En cas d'erreur côté serveur, annuler la mise à jour locale
      setNotifications(notifications);
    }
  };

  const handleDeleteNotification = async (notificationId) => {
    try {
      // Check if the user exists before deleting the notification
      const userResponse = await fetch(`/user/details-user`);
      if (userResponse.status === 200) {
        const userData = await userResponse.json();
        const userExists = userData && userData.userId;

        if (userExists) {
          // Delete the notification on the server
          const response = await fetch(`/user/delete-notifications/${notificationId}`, {
            method: 'DELETE',
          });

          if (response.status === 200) {
            // If deletion is successful, update the notifications state locally
            setNotifications((prevNotifications) =>
              prevNotifications.filter((notification) => notification._id !== notificationId)
            );
          } else {
            console.error(`Error deleting notification: ${response.status}`);
          }
        } else {
          console.error('User not found for notificationId:', notificationId);
        }
      } else {
        console.error(`Error fetching user details: ${userResponse.status}`);
      }
    } catch (error) {
      console.error('Unexpected error deleting notification:', error);
    }
  };

  const handleDisconnect = async () => {
    try {
      const response = await fetch('/user/logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        navigate("/connexion")
      } else {
        console.error('Error disconnecting user:', response.status);
      }
    } catch (error) {
      console.error('Unexpected error disconnecting user:', error);
    }
  };

  const filtreRecherche = medias.filter((media) => {
    const nomComplet = `${media.nom}`.toLowerCase();
    return nomComplet.includes(recherche.toLowerCase());
  });

  const handleSearchFocus = (focused) => {
    setIsSearchFocused(focused);
  };

  const handleRecherche = (e) => {
    setRecherche(e.target.value);
  };

  const handleSearchBlur = () => {
    setIsSearchFocused(false);
    // Reset the value to its default state
    setRecherche('');
  };

  const [isMenuOpen, setIsMenuOpen] = useState(window.innerWidth > 390);
      ;

  // Fonction pour basculer l'état du menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


  const burgerButtonClass = isMenuOpen ? "burger open" : "burger";

  return (
    <header>
     
      <div className={burgerButtonClass} onClick={toggleMenu}>
        <div>›</div></div>
      {isMenuOpen && (
      <div className="menu">
        <ul className="nav">
          <Link to="/" className="content">
            <h2>LFlex</h2>
            <h2>LFlex</h2>
          </Link>
          <div className="menu_nav">
            <li>
              {' '}
              <input
                className="input"
                placeholder="Recherche..."
                value={recherche}
                onChange={handleRecherche}
                onFocus={() => handleSearchFocus(true)}
                onBlur={handleSearchBlur}
              />
            </li>
            <li>
              <Link to="/acceuil" className="button-menu">
                Accueil<div className="arrow">›</div>
              </Link>
            </li>
            <li>
              <Link to="/series" className="button-menu">
                Séries <div className="arrow">›</div>
              </Link>
            </li>
            <li>
              <Link to="/films" className="button-menu">
                Films <div className="arrow">›</div>
              </Link>
            </li>
            <li>
              <Link to="/news" className="button-menu">
                Nouveautés <div className="arrow">›</div>
              </Link>
            </li>
            <li>
              <Link to="/maListe" className="button-menu">
                Ma liste <div className="arrow">›</div>
              </Link>
            </li>
          </div>
        </ul>
        <ul className="nav2">
          <li className="notif button-menu">
            <Link>
              Notifications
            </Link>
            <span className="red_point">{notifications.filter((notification) => !notification.isRead).length}</span>
            <div className="arrow">›</div>
            <div className="notification-dropdown">
              {notifications.map((notification) => (
                <div
                  key={notification._id}
                  className={`notification-item ${notification.isRead ? 'read ' : 'unread'}`}
                  onClick={() => handleNotificationClick(notification._id)}
                >
                  <div className={`${notification.isRead ? 'bluebar' : 'redbar'}`}></div>
                  <p>{notification.title}</p>
                  <p>{notification.message}</p>
                  <button className="delete-notif" onClick={() => handleDeleteNotification(notification._id)}>
                    X
                  </button>
                </div>
              ))}
            </div>
          </li>
          <div>
            <li className="btn-profile button-menu">
              <Link to={`/liste_profile/${user.userId}`} className="profile_menu">
                <p>Bienvenue</p>
                <div className="picture_profile_menu" style={{ backgroundImage: `url(${profilePic})` }}></div>
                <div className="arrow">›</div>
              </Link>
              <div className="extension_profile">
                <ul className="ext_open">
                  <li className="button-menu btn-over-prof">
                    <Link to={`/liste_profile/${user.userId}`}>Profile</Link>
                  </li>
                  <li className="button-menu btn-over-prof">
                    <Link to={`/create_profile/${selectedProfileId}`}>Créer un Profile</Link>
                  </li>
                </ul>
              </div>
            </li>
          </div>
        </ul>
        <button className="btn-disconnect" onClick={handleDisconnect}>
          <div className="sign-disconnect">
            <svg viewBox="0 0 512 512">
              <path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"></path>
            </svg>
          </div>
          <div className="text-disconnect">Se déconnecter</div>
        </button>
      </div>
      )}
      <div className={`searchMedia ${isSearchFocused ? 'searchMediaVisible' : 'searchMediaHidden'}`}>
        <div className="container_news favs">
          <div>
            <h2>Rechercher</h2>
          </div>
          <div className="liste favsList">
            {filtreRecherche.map((media) => (
              <Link
                key={media._id}
                className="carte"
                to={`/video/${media._id}`}
                style={{
                  backgroundImage: `url(${media.url})`,
                }}
              >
                <h3>{media.nom}</h3>
                <div className="overlay">
                  <img
                    src="https://cdn0.iconfinder.com/data/icons/google-material-design-3-0/48/ic_play_circle_filled_white_48px-512.png"
                    alt=""
                  />
                </div>
                <h3>{media.nom}</h3>
              </Link>
            ))}
          </div>
        </div>
      </div>

      

    </header>
  );
}

export default Header;
